module.exports = __webpack_public_path__ + "img/icon_credit.2832b766.svg";